<div class="page background-pattern" fxLayout="column" fxLayoutAlign="center center">
  <div [@fadeInUp] class="card border-radius elevation">
    <div class="header padding" fxLayout="column" fxLayoutAlign="center center">
      <div class="logo fill-primary-contrast">
       <img src="../../../../assets/img/elite-logo.svg" alt="logo"/>
      </div>
    </div>
    <form [formGroup]="loginForm">
      <div class="padding" fxLayout="column" fxLayoutGap="16px">
        <div fxFlex="auto" fxLayout="column">
          <mat-form-field fxFlex="grow" appearance="outline">
            <mat-label>E-Mail</mat-label>
            <input matInput required formControlName="emailAddress" autocomplete="off">
            <mat-error *ngIf="loginForm.controls['emailAddress'].hasError('required')">We need an email address to log you in
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="grow" appearance="outline">
            <mat-label>Password</mat-label>
            <input matInput [type]="inputType" formControlName="password" autocomplete="off" required>
            <button type="button" mat-icon-button matSuffix (click)="toggleVisibility()" matTooltip="Toggle Visibility">
              <mat-icon *ngIf="visible">visibility</mat-icon>
              <mat-icon *ngIf="!visible">visibility_off</mat-icon>
            </button>
            <mat-hint>Click the eye to toggle visibility</mat-hint>
            <mat-error *ngIf="loginForm.controls['password'].hasError('required')">We need a password to log you in
            </mat-error>
          </mat-form-field>
        </div>
  
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <mat-checkbox class="caption" formControlName="rememberMe">Remember Me</mat-checkbox>
          <a class="caption" [routerLink]="['/forgot-password']">Forgot Password?</a>
        </div>
        <button type="button" class="sub-button" mat-raised-button (click)="login()" [disabled]="isLoading">
          START WORKING
        </button>
        <!-- <p class="secondary-text text-center">
          Don't have an account?<br/>
          <a [routerLink]="['/register']">Click here to create one</a>
        </p> -->
        <small class="secondary-text text-center">
          COPYRIGHT © 2020 ELITE HOME WARRENTY. ALL RIGHTS RESERVED
        </small>
      </div>
    </form>
    
  </div>
</div>
